import React from 'react';

const TopPicksIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.38875 7.41168C5.33243 5.08512 6.73113 3.75955 7.30866 1.6358C10.288 3.30331 13.9589 7.54868 13.6825 10.7037C13.3963 13.9713 10.4498 14.6753 9.25606 14.9605L9.22913 14.967C9.22266 14.9685 9.21906 14.9604 9.22366 14.9556C10.4949 13.616 10.9382 12.2707 11.0745 11.5039C11.3182 9.03762 9.45813 7.42128 8.58766 6.98718C8.58166 6.98418 8.57586 6.99095 8.57933 6.99668C9.02513 7.74322 8.69799 9.91422 8.04186 10.6404C7.67646 9.02835 6.34015 8.60642 5.72103 8.32228C5.71605 8.31995 5.71092 8.32468 5.71201 8.33008C6.03899 9.93288 4.85262 10.6952 4.69009 11.8441C4.48824 13.271 5.47689 14.2199 5.91058 14.8714C5.91411 14.8767 5.90825 14.8829 5.90224 14.8808C1.50522 13.3205 1.89635 8.98035 3.38875 7.41168Z",
      stroke: "#E2E4EE"
    }
  )
);
TopPicksIcon.displayName = "Icons.TopPicksIcon";

export { TopPicksIcon };
//# sourceMappingURL=TopPicksIcon.js.map
